// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__31iL8","requiredAsterisk":"Info_requiredAsterisk__1iNGk"};